import { CurationQueueItem, CurationSnapshotPayload } from '../interfaces/curation.interface';

export interface CurationSnapshotView {
  line: string;
  code: string;
  description: string;
  action: string;
  severity: string;
}

export function buildCurationSnapshotView(item: CurationQueueItem | null | undefined): CurationSnapshotView {
  const snapshot = normalizeSnapshot(item?.snapshot ?? item?.findingSnapshot ?? item?.finding_snapshot);

  return {
    line: textValue(firstValue(snapshot, 'line', 'lineNumber', 'line_number')),
    code: textValue(firstValue(snapshot, 'code', 'sourceCode', 'source_code', 'codeSnippet', 'code_snippet', 'snippet')),
    description: textValue(firstValue(snapshot, 'description', 'message')),
    action: textValue(firstValue(snapshot, 'action', 'suggestedAction', 'suggested_action')),
    severity: textValue(firstValue(snapshot, 'severity'))
  };
}

function normalizeSnapshot(snapshot: CurationSnapshotPayload | undefined): Record<string, unknown> {
  if (!snapshot) {
    return {};
  }

  if (typeof snapshot === 'string') {
    const trimmed = snapshot.trim();
    if (!trimmed) {
      return {};
    }

    try {
      const parsed = JSON.parse(trimmed);
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed as Record<string, unknown> : {};
    } catch {
      return { code: snapshot };
    }
  }

  return snapshot as Record<string, unknown>;
}

function firstValue(snapshot: Record<string, unknown>, ...keys: string[]): unknown {
  for (const key of keys) {
    const value = snapshot[key];
    if (value !== undefined && value !== null && value !== '') {
      return value;
    }
  }
  return undefined;
}

function textValue(value: unknown): string {
  if (value === undefined || value === null) {
    return '';
  }
  return String(value);
}
